import React, { useContext, useEffect, useState } from "react";
import useFetch from "../Hooks/useFetch";
import { ageGroupsURL } from "../Hooks/URL";
import { useParams } from "react-router-dom";
import { userContext } from "../Contexts/userContext";
import AddMission from "../Templates/Home/Missions/AddMission/AddMission";

function AddMissionPage() {
  const { contextData, setContextData } = useContext(userContext);
  let { ageGroupId } = useParams();

  const url = `${ageGroupsURL}/${ageGroupId}`;

  const [category, setCategory] = useState({});

  const { data, loading, error } = useFetch(url);

  useEffect(() => {
    if (!loading && !error && data) {
      setCategory(data?.data);
    }
  }, [data, loading, error]);

  return (
    <AddMission
      category={category}
      loading={loading}
    />
  );
}

export default AddMissionPage;

